import { AQA_ELEMENTS_MARKER_LIST } from 'features/order-tracker/utils/aqaElementsIDList';

export const BUTTON_TXT = 'View order status';
export const ORDER_NUMBER_LABEL = 'Order number';
export const POST_CODE_LABEL = 'Postcode';
export const ORDER_NUMBER_TOOLTIP_TITLE = 'Your order number will look like one of these:';
export const ORDER_NUMBER_TOOLTIP_ANALYTICS = 'Reference number info';
export const POST_CODE_TOOLTIP_TITLE = 'You can use billing address postcode for tracking order.';
export const POST_CODE_TOOLTIP_ANALYTICS = 'Post code info';
export const POST_CODE = 'POST_CODE';
export const ORDER_NUMBER = 'ORDER_NUMBER';
export const POST_CODE_EMPTY_TEXT = 'Please enter your postcode';
export const POST_CODE_INVALID_TEXT = 'Please enter a valid postcode';
export const ORDER_NUMBER_EMPTY_TEXT = 'Please enter your order reference';
export const ORDER_NUMBER_INVALID_TEXT = 'Please enter a valid order reference';

export const KEY_ENTER = 'Enter';
export const DEFAULT_VALIDATION_STATUS = {
  orderNumber: {
    isValid: true,
    errorMassage: '',
  },
  postCode: {
    isValid: true,
    errorMassage: '',
  },
};

export const ORDER_NUMBER_TOOLTIP_PROPS = {
  id: AQA_ELEMENTS_MARKER_LIST.entryPage.ornTooltip,
  analytics: ORDER_NUMBER_TOOLTIP_ANALYTICS,
  hints: [
    { label: 'BT12345678', message: 'Starts with BT followed by 6-28 characters.' },
    { label: 'GBT1234567', message: 'Starts with GBT followed by 5-27 characters.' },
    { label: 'PX-1234567', message: 'Starts with PX followed by 8-30 characters.' },
  ],
};

export const POST_CODE_TOOLTIP_PROPS = {
  id: AQA_ELEMENTS_MARKER_LIST.entryPage.pcodeTooltip,
  analytics: POST_CODE_TOOLTIP_ANALYTICS,
};
